<template>
    <div
        class="l-ss-c-catalog">
        <catalog-btn
            :text="activeCategoryLabel"
            :is-mobile="isMobile"
            :is-opened="isVisible"
            :selected-category="localSelectedCategory"
            @click="toggleList"
            @clear="clearCategory"/>
        <template v-if="isVisible">
            <catalog-desktop
                v-if="!isMobile"
                v-model="selectedCategory"
                :style="popupStyle"
                :categories="mappedCategories"
                @change="onCategorySelect"/>
            <catalog-mobile
                v-else
                v-model="selectedCategory"
                :style="popupStyle"
                :categories="mappedCategories"
                @change="onCategorySelect"/>
        </template>
    </div>
</template>

<script>
    import { computed, watch, ref, provide, nextTick } from '@vue/composition-api';

    import CatalogBtn from '@/core/components/catalog/catalog-btn.vue';

    import iconBurger from '@/core/assets/images/icons/burger-icon.svg';
    import iconArrowRight from '@/core/assets/images/icons/arrow-right.svg';
    import iconGallery from '@/core/assets/images/icons/gallery-icon.svg';
    import CatalogDesktop from '@/core/components/catalog/catalog-desktop.vue';
    import CatalogMobile from '@/core/components/catalog/catalog-mobile.vue';

    export default {
        components: { CatalogMobile, CatalogDesktop, CatalogBtn },
        props: {
            isLoading: {
                type: Boolean,
                default: true,
            },
            hasQuery: {
                type: Boolean,
                default: false,
            },
            hasFilters: {
                type: Boolean,
                default: false,
            },
            categories: {
                type: Array,
                required: true,
            },
            available: {
                type: Boolean,
                default: true,
            },
        },
        setup(props, { root, emit }) {
            const isMobile = root.$screen.isMobile;

            const defaultCategoryLabel = root.$t('categories.isNoCategory');

            const mappedCategories = computed(() =>
                [{ id: '', title: defaultCategoryLabel, level: 0, child: [] }, ...props.categories].filter((category => category.id !== 'global')),
            );

            const currentCategory = ref(isMobile ? null : mappedCategories.value[0] || null);
            const popupStyle = ref(null);

            const selectedCategory = computed({
                get() {
                    if (isMobile) {
                        return currentCategory.value;
                    } else {
                        return currentCategory?.value || mappedCategories.value[0] || null;
                    }
                },
                set(value) {
                    currentCategory.value = value;
                },
            });

            const localSelectedCategory = ref(selectedCategory.value);

            const isVisible = computed(() => {
                return root.props.store.state.ui.isCategoriesListVisible;
            });

            const activeCategoryLabel = computed(() => {
                return selectedCategory.value.title;
            });

            const toggleList = (event) => {
                emit('toggle');
                emit('button-everywhere-click', { type: 'buttonEverywhereClick', event });
            };

            const emitCategory = (categoryId, showList, event) => {
                emit('toggle', showList);

                nextTick(() => {
                    emit('change', { categoryId, skip: 0 });
                    emit('rubricator-category-click', { type: 'rubricatorCategoryClick', event, categoryId });
                });

                emit('update-category-id', categoryId);
            };

            const onCategorySelect = (data) => {
                const { event, category } = data;

                event.preventDefault();
                event.stopPropagation();

                localSelectedCategory.value = category;

                root.props.store.commit('ui/SET_PROPERTY', { key: 'isCategorySearch', value: true });

                emitCategory(category.id, false, event);
            };

            const clearCategory = (event) => {
                const data = {
                    event,
                    category: mappedCategories.value[0],
                };

                onCategorySelect(data);
            };

            watch(isVisible, () => {
                if (isVisible.value) {
                    const searchPopup = root.$el.querySelector('.l-ss-c-search-top-section-wrapper');

                    const searchPopupRect = searchPopup.getBoundingClientRect();

                    popupStyle.value = {
                        height: `calc(100vh - ${searchPopupRect.top + searchPopupRect.height}px)`,
                    };
                }
            });

            provide('makeCategoryUrl', (categoryId) => {
                return `#/search/categoryId=${categoryId.value}&skip=0`;
            });

            return {
                iconBurger,
                iconGallery,
                iconArrowRight,
                isVisible,
                activeCategoryLabel,
                selectedCategory,
                localSelectedCategory,
                mappedCategories,
                popupStyle,
                toggleList,
                onCategorySelect,
                clearCategory,
                isMobile,
            };
        },
    };
</script>
